import AssignmentDetails from "../../fragments/assignment-details";
import BackButton from "../../util/back-button";

function CustomerAssignmentDetails({ customerId, subpage }) {
  return <>
    <BackButton />
    <AssignmentDetails id={subpage} preselectedCustomerId={customerId} />
  </>
}

export default CustomerAssignmentDetails;